import React from 'react';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';
import SelectField from '../app-main/components/reduxForms/fields/SelectField/SelectField';
import Button from '../elements-buttons/Button';
import { get, map } from 'lodash';
import { FormattedMessage } from 'react-intl';

const AddonsHeader = ({
  spaceId,
  spaces,
  inventoryData,
  ...props
}) => {
  const selectFieldInput = {
    name: 'spaces-select',
    value: spaceId,
    onChange: (spacesId) => {
      return props.dispatch(push(`/hosting/add-ons/${spacesId}`));
    }
  };
  const selectFieldOptions = map(spaces.data, (space = {}) => {
    return {
      label: (
        <div>
          <div className="ellipsis">{space.title}</div>
          <div className="text-gray-600 text-small ellipsis">{space.street}</div>
        </div>
      ),
      value: get(space, '_id')
    };
  });

  return (
    <div className="ManageAddonsHeader">
      <div className="ps-container-lg-margin ps-container-fixed">
        <div className="ps-row">
          <div className="col-xs-12">
            <div>
              <h2><FormattedMessage id="hosting.add_ons_header.add_on_inventory_heading" defaultMessage="Add-on Inventory"/></h2>
              <p className="text-gray-600">
                <FormattedMessage id="hosting.add_ons_header.add_on_inventory_text" defaultMessage="Add-ons are shown on your listings and can be purchased during checkout."/>
              </p>
            </div>
            <div className="flex header-cta-container margin-lg-top">
              <div className="flex-basis-35-sm">
                <SelectField
                  input={selectFieldInput}
                  options={selectFieldOptions}
                  classNamePrefix="Multiline"
                />
              </div>
              {
                0 !== inventoryData.length &&
                <div className="flex-basis-65-sm text-right">
                  <Button
                    category="primary"
                    onClick={() => props.toggleModal('createAddOnModal')}
                  >
                    <span className="text-large">+</span>
                    <span> <FormattedMessage id="hosting.add_ons_header.add_on_inventory_button_text_add_itm" defaultMessage="Add Item"/></span>
                  </Button>
                </div>
              }
            </div>
            { 0 !== inventoryData.length && <hr className="margin-lg-bottom" /> }
          </div>
        </div>
      </div>
    </div>
  );
};

AddonsHeader.propTypes = {
  toggleModal: PropTypes.func,
  spaceId: PropTypes.string,
  spaces: PropTypes.array,
  inventoryData: PropTypes.array,
  dispatch: PropTypes.func
};

export default AddonsHeader;
